import { useMemo, useState } from "react";
import { EmployeeStory } from "interfaces/api/apiInterfaces";

export const useEmployeeModal = ({ employeeStories }: { employeeStories: EmployeeStory[] }) => {
    const [modalOpen, setIsOpen] = useState<boolean>(false);
    const [openStoryId, setOpenStoryId] = useState<string|null>(null);
    const openStory = useMemo(() => openStoryId && (employeeStories || [])
        .find(({ id }) => id === openStoryId), [employeeStories, openStoryId]);
    const setOpenStory = (id: string|null) => {
        setOpenStoryId(id);
        setIsOpen(true);
    };

    return {
        isOpen: !!openStory && modalOpen,
        openStory,
        setIsOpen,
        setOpenStory,
        setOpenStoryId,
    };
};
